export default __webpack_public_path__ + "static/media/sun.e6673536.png";